var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonWingLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 82,
    viewBox: "0 0 49 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6594 24.1188C28.1871 23.7153 28.8079 23.4256 29.4908 23.1979C29.6977 23.1255 29.915 23.0634 30.1323 22.991C30.3289 22.6392 30.5255 22.2977 30.7221 21.9563C33.2881 17.476 36.3198 13.12 39.8171 9.21916C39.8067 8.8984 39.7964 8.5673 39.786 8.22585C39.7136 5.82535 39.8688 2.19356 40.9759 0C39.0928 0.962269 36.2163 0.65186 33.7744 2.02801C31.1463 3.51797 26.2522 7.83266 25.4555 10.7919C24.4311 14.5996 27.2041 18.8625 27.7732 20.7353C27.8767 21.0871 27.8767 23.3014 27.649 24.1085L27.6594 24.1188Z",
    fill: "url(#paint0_linear_318_3152)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6168 7.27344C27.71 8.97034 28.3515 11.019 29.8828 12.9022C29.262 11.4019 28.8585 9.63255 29.738 8.03911C29.8725 9.87053 30.8451 11.1949 32.1385 12.9643C32.0971 14.5784 32.2316 15.8407 31.828 17.3824C28.9102 14.8785 26.9443 13.5127 25.9199 9.66359C26.3235 8.89791 26.9236 8.0805 27.6168 7.27344Z",
    fill: "url(#paint1_linear_318_3152)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1094 17.2045C32.4405 15.1558 32.2128 13.045 32.4405 10.9756C33.0716 5.28477 37.8105 2.07721 40.9767 0.0078125C39.8696 2.20137 39.7144 5.84351 39.7868 8.23366C39.7868 8.57511 39.8075 8.90621 39.8179 9.22697C36.3206 13.1174 33.2889 17.4839 30.7229 21.9641C30.5263 22.3055 30.3297 22.6573 30.1331 22.9988C29.9055 23.0712 29.6882 23.1333 29.4916 23.2057C28.8087 23.4334 28.1879 23.7127 27.6602 24.1266C29.8434 22.0262 31.6024 20.2982 32.1094 17.2148V17.2045Z",
    fill: "url(#paint2_linear_318_3152)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7526 17.6419C29.046 18.8525 30.7118 19.3181 32.357 19.2353C31.7879 20.1355 31.2499 21.0564 30.7222 21.9669C30.5256 22.3084 30.329 22.6602 30.1324 23.0016C29.9048 23.0741 29.6875 23.1362 29.4909 23.2086C28.808 23.4362 28.1872 23.7156 27.6595 24.1295C27.8871 23.3224 27.8871 21.1185 27.7836 20.7564C27.3077 19.1733 25.259 15.8933 25.2383 12.6133C25.497 14.5068 26.0453 16.0278 27.7526 17.6419Z",
    fill: "#5795CC"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7762 6.70231C39.621 5.42963 39.5382 3.76377 38.9071 2.72907C37.9345 1.12529 35.2236 1.87027 33.8784 2.47039C32.3574 3.15329 31.0641 4.12591 29.75 5.09853C31.1779 3.78446 32.6782 2.66699 33.7853 2.03582C36.2272 0.649325 39.1037 0.959734 40.9868 0.0078125C40.097 1.7668 39.8176 4.46736 39.7866 6.70231H39.7762Z",
    fill: "url(#paint3_linear_318_3152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9766 0.0078125C35.8238 3.16364 32.8853 6.41259 32.0886 10.9135C30.8883 8.11984 30.7538 6.82647 31.7678 3.6603L31.2608 4.78812C30.4227 7.14723 30.9711 9.09246 31.8402 11.255C31.9334 11.4826 31.9334 11.8551 31.892 12.6208C31.7781 14.6384 31.7988 15.9732 31.7575 16.9872C28.9948 15.042 27.5152 13.583 26.0977 10.3444C27.0703 13.4692 28.7879 15.2075 31.2401 17.0389C31.5816 17.2976 31.7368 17.6805 31.685 18.1047C31.685 18.1668 31.6643 18.2288 31.654 18.2909C31.3953 19.8637 30.4537 21.2088 27.66 24.1163C29.8846 22.4194 31.2401 20.8466 31.9023 19.4394C32.0265 19.1601 32.2645 18.9842 32.5542 18.9221C32.6369 18.7876 32.7197 18.6531 32.8025 18.5289C32.6163 18.5599 32.4197 18.5806 32.2127 18.6013C32.5128 17.5149 32.43 16.3353 32.3886 14.9075C35.6479 13.9555 37.3138 12.062 38.7106 8.98899C39.1555 8.00603 39.2901 7.55076 39.5073 6.50571C39.2073 7.39556 38.9796 8.05776 38.5554 8.91656C37.1172 11.8241 35.5238 13.6555 32.3783 14.535C32.3472 13.2519 32.3679 11.7723 32.7197 9.99265C33.6923 5.04679 37.769 2.29449 40.9766 0.0181595V0.0078125Z",
    fill: "url(#paint4_linear_318_3152)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0102 39.9939C16.8166 38.7626 14.8197 36.8794 13.7125 34.5514C11.5811 30.0815 10.4532 26.0358 10.5464 22.0729C11.4465 23.3145 12.3778 24.2251 13.8057 25.2391C12.6158 23.9354 11.3638 21.8556 10.6705 20.2725C10.6809 20.1484 10.7016 20.0242 10.7223 19.8897C11.4569 14.6438 15.2025 6.37654 15.7819 2.35156C18.3273 5.52808 21.8142 8.38385 25.0735 11.4983C25.5598 11.9536 26.0358 12.4295 26.5221 12.9158C26.3462 13.6712 26.0979 14.4989 25.9427 15.1922C25.7668 15.9682 26.3048 15.9268 26.8118 15.5026C27.2257 15.1611 27.5878 14.6852 27.8155 14.2506C29.3779 15.9061 30.8885 17.6754 32.1819 19.5172C31.6749 20.3346 31.1886 21.152 30.723 21.9694C27.712 27.2153 24.9804 33.1028 23.3559 38.9385L23.2731 39.2385L23.3559 39.5386C23.5215 40.1387 23.7077 40.7388 23.894 41.3493C22.0936 41.101 20.3346 40.7492 19.0102 40.0042V39.9939Z",
    fill: "url(#paint5_linear_318_3152)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6834 29.6883C18.586 20.6243 17.4478 12.0363 15.7819 2.35156C15.2025 6.37654 11.4569 14.6541 10.7223 19.8897C10.7016 20.0139 10.6912 20.138 10.6705 20.2725C11.3638 21.8556 12.6054 23.9354 13.8057 25.2391C12.3778 24.2251 11.4362 23.3145 10.5464 22.0729C10.4532 26.0358 11.5811 30.0815 13.7125 34.5514C14.8197 36.8691 16.8166 38.7626 19.0102 39.9939C20.3346 40.7388 22.1039 41.0906 23.894 41.339C23.7077 40.7388 23.5215 40.1284 23.3559 39.5283L23.2731 39.2282L23.3559 38.9281C23.8008 37.314 24.3389 35.6895 24.939 34.0857C24.1526 32.7303 23.4076 31.2921 22.6834 29.6883Z",
    fill: "url(#paint6_linear_318_3152)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9811 11.0301C12.6257 14.2377 11.5599 17.6212 11.0426 21.0564C10.9081 20.7873 10.7839 20.5287 10.6804 20.2803C10.6908 20.1562 10.7115 20.032 10.7322 19.8975C11.4668 14.6516 15.2124 6.38435 15.7918 2.35938C18.1716 5.32896 21.3688 8.00882 24.4316 10.8853C22.238 8.98144 19.1546 6.47747 17.4577 6.58094C16.1954 6.66372 14.9537 8.73311 13.9915 11.0301H13.9811ZM10.5459 22.0704C10.6494 22.2152 10.7528 22.3497 10.8563 22.4842C10.7632 23.3327 10.7115 24.1812 10.6908 25.0296C10.5666 24.0363 10.5149 23.0533 10.5459 22.0807V22.0704Z",
    fill: "url(#paint7_linear_318_3152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4051 24.0169C23.4265 20.2816 25.2061 17.1051 26.1581 12.5421C25.7959 12.18 25.4338 11.8282 25.0716 11.4867C24.4405 10.8866 23.7989 10.2968 23.1678 9.70703C23.6748 14.3839 21.0777 19.9298 19.6602 21.5957C19.8878 22.4131 20.1361 23.2202 20.4051 24.0169Z",
    fill: "url(#paint8_linear_318_3152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3066 15.8633C27.2269 19.8262 23.5434 23.4787 20.8945 25.3722C21.7844 27.7002 22.8501 29.9559 24.009 32.1908C25.0333 31.539 25.9645 30.6388 26.8027 29.5937C27.9926 26.9552 29.3273 24.3892 30.7242 21.9576L30.8276 21.7818C31.1794 20.7471 31.4691 19.7434 31.6968 18.8122C30.9518 17.7982 30.1447 16.8152 29.3066 15.8633Z",
    fill: "url(#paint9_linear_318_3152)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3874 35.6343C24.0046 36.731 23.6631 37.8278 23.3631 38.9246L23.2803 39.2247L23.3631 39.5247C23.5286 40.1249 23.7149 40.725 23.9011 41.3354C22.1007 41.0871 20.3417 40.7353 19.0173 39.9903C16.8238 38.7591 14.8268 36.8759 13.7197 34.5478C12.3953 31.7541 11.4537 29.1364 10.957 26.6014C14.1025 34.3719 19.752 36.7828 24.3978 35.6446L24.3874 35.6343ZM32.189 19.5033C31.9407 19.9069 31.6924 20.3207 31.444 20.7346C30.9888 18.9446 30.2024 17.5477 29.0332 15.5508C30.161 16.8131 31.2371 18.1375 32.189 19.5033Z",
    fill: "url(#paint10_linear_318_3152)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7806 2.34628C16.5463 7.74741 17.1464 12.745 18.2018 17.5874C16.0393 15.6939 15.3357 14.8247 13.6181 12.3415C14.6631 14.8454 15.9462 16.2216 17.8397 18.0013C18.2328 18.3738 18.4812 18.7876 18.6053 19.3153C19.2986 22.1711 20.1781 24.9855 21.3783 27.7999C17.374 27.2308 14.1768 25.6063 11.2383 22.9678C13.5146 25.8753 17.2188 27.7481 21.13 28.5034C21.5232 28.5759 21.8232 28.8139 21.9888 29.1657C22.5165 30.3142 23.1063 31.473 23.7581 32.6422C24.0996 33.2527 24.4514 33.8632 24.8032 34.4737C24.917 34.1529 25.0411 33.8321 25.1653 33.5114C24.9791 33.1699 24.7928 32.8388 24.6169 32.5077C25.0929 32.2387 25.5585 31.8559 26.0138 31.3903C26.3552 30.5935 26.6967 29.8072 27.0588 29.0208C26.169 30.2417 25.2067 31.235 24.2341 31.7731C22.5268 28.3586 21.2128 25.0476 20.147 21.7469C22.113 17.9599 23.5615 15.2179 23.2304 10.748C22.9407 15.2076 21.9784 17.2356 19.878 20.8881C18.0052 14.8661 16.9188 8.86488 15.7806 2.33594V2.34628ZM30.8251 21.7779C30.9803 21.5089 31.1355 21.2295 31.3011 20.9605C31.3942 20.5052 31.4666 20.081 31.4873 19.7085C31.3321 20.2983 31.1045 21.0122 30.8251 21.7676V21.7779ZM24.3065 35.8601C24.3686 35.6739 24.4307 35.4877 24.5031 35.3014C20.4574 35.6118 16.7843 34.8151 13.6181 33.0458C16.598 35.26 20.4678 36.0257 24.3169 35.8601H24.3065Z",
    fill: "url(#paint11_linear_318_3152)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2466 60.5831C30.4633 60.7693 25.3415 63.6561 22.7755 63.6768C16.05 63.7286 10.2763 59.3932 6.13755 54.4059C7.74133 55.1095 9.4072 55.0268 11.1144 54.737C9.00367 54.3646 5.6202 52.947 3.94399 51.2398C1.49176 46.9458 -0.0602859 41.2135 0.00179593 36.6919C0.0535308 33.0187 0.581227 29.2938 0.239776 25.9414C1.81252 28.4661 3.42665 29.9457 5.56847 31.0321C6.86184 32.3255 7.47231 33.2981 8.60013 35.0364C8.73465 33.8155 8.63118 33.0394 8.42424 32.1806C10.7627 32.9463 13.6805 33.5982 17.4882 34.5811C19.6507 35.1399 21.865 35.5641 24.0068 36.216C23.7274 37.0541 23.4687 37.8922 23.2411 38.7406L23.1583 39.0407L23.2411 39.3407C24.9484 45.4662 27.8869 51.695 31.1048 57.1686C31.7877 58.3171 32.4913 59.4656 33.2363 60.6038L33.2466 60.5831Z",
    fill: "url(#paint12_linear_318_3152)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24244 54.5987C10.3916 59.586 16.1548 63.9213 22.8804 63.8696C25.4464 63.8489 30.5682 60.9621 33.3515 60.7759C33.0308 60.2896 32.7204 59.8032 32.4203 59.3169C27.0192 54.2676 18.8658 53.8537 11.1469 46.3108C5.34225 40.651 1.38971 33.1184 0.355011 26.1445C0.686114 29.497 0.158418 33.2219 0.11703 36.895C0.0549485 41.4167 1.607 47.1489 4.04888 51.4429C5.72509 53.1501 9.10855 54.5677 11.2193 54.9402C9.51209 55.2195 7.85657 55.3127 6.24244 54.6091V54.5987Z",
    fill: "url(#paint13_linear_318_3152)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.554 56.9274C27.7129 56.0065 28.6234 55.0132 29.327 53.9682C29.9478 55.1167 30.579 56.2548 31.2308 57.3516C31.9137 58.5001 32.6173 59.6487 33.3623 60.7868C30.579 60.9731 25.4572 63.8599 22.8912 63.8806C17.2003 63.922 12.1924 60.8282 8.28125 56.855C13.0822 59.7211 21.2667 61.1283 26.5644 56.9378L26.554 56.9274ZM24.1225 36.4093C24.0811 36.5335 24.0397 36.6577 23.9983 36.7818C23.4499 36.4507 22.8705 36.161 22.2704 35.9023C22.8912 36.0575 23.512 36.2231 24.1225 36.4093Z",
    fill: "url(#paint14_linear_318_3152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7293 42.911C21.243 40.5312 19.3909 37.0649 17.0111 34.623C16.3385 34.4471 15.6866 34.2919 15.0762 34.1367C16.742 35.9267 17.5698 37.7375 18.4286 40.2104C20.0117 44.7734 19.2977 47.3912 18.6459 52.068C19.5461 52.5543 20.4256 52.9786 21.2844 53.3924C22.2156 49.5641 22.3708 45.9944 21.7396 42.9213L21.7293 42.911Z",
    fill: "url(#paint15_linear_318_3152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71374 45.1636C4.10996 42.8252 2.00952 39.2866 1.28523 36.5757C0.943783 35.303 0.436781 32.1678 1.57495 31.1125C1.92675 30.7813 2.45444 30.6468 3.18908 30.8538C5.11362 31.3711 7.01746 33.3474 8.37291 34.6925C7.46238 33.2853 6.85191 32.3851 5.70339 31.247C3.56157 30.1709 1.93709 28.6913 0.374699 26.1562C0.705803 29.5087 0.178107 33.2336 0.136719 36.9068C0.136719 37.0102 0.136719 37.1034 0.136719 37.2068C1.04725 40.4558 2.7545 42.132 5.73443 45.174L5.71374 45.1636Z",
    fill: "url(#paint16_linear_318_3152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4336 53.9106C23.5304 54.3555 24.5858 54.8108 25.6722 55.2868C25.8998 54.2728 26.562 51.0445 26.5724 48.3336C25.9102 46.8436 25.2997 45.3226 24.741 43.8016C24.7203 43.7706 24.6892 43.7395 24.6685 43.7085C23.9753 42.7773 23.6131 41.7219 22.7647 40.832C23.9856 45.1985 23.7063 48.9544 22.4336 53.9106Z",
    fill: "url(#paint17_linear_318_3152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.351562 26.1445C1.12759 35.2499 8.267 45.9797 15.4581 50.8117C16.6377 51.6084 17.8586 52.2706 19.0796 52.8604C12.2195 52.9329 8.99129 52.1051 3.07282 48.2043C6.03205 50.4703 9.41551 52.5707 11.0193 52.9122C13.5129 53.4502 16.2135 53.4709 19.1727 53.4916C20.0419 53.4916 20.3523 53.4605 22.2354 54.2469C23.4978 54.7746 24.7497 55.2816 25.981 55.8507C26.8191 56.2335 27.5848 56.5853 28.2987 56.9371C20.9938 58.9341 18.0759 60.9725 10.1088 57.8063C13.8854 59.8964 17.2275 60.4655 20.404 59.9274C23.1563 59.4618 25.6085 57.8787 28.9403 57.2579C30.244 57.9408 31.4339 58.6961 32.7376 59.8136C32.5824 59.5653 32.4272 59.3273 32.272 59.079C31.0304 57.9511 29.2714 56.6785 27.44 55.7679C27.5745 54.3193 27.7814 52.819 27.978 51.3601C27.8642 51.1325 27.7504 50.8945 27.6365 50.6669C27.4399 52.1775 27.1502 53.771 26.8295 55.4886C26.6743 55.4161 26.5191 55.354 26.3639 55.2816C23.684 54.1641 21.2732 53.1605 19.0692 51.9602C19.2555 48.494 19.9487 45.3278 19.5866 43.3412C19.0589 40.413 17.8276 37.2572 15.4478 34.4532C18.5622 39.668 19.5659 43.9103 18.4691 51.6291C17.5793 51.1221 16.7205 50.5737 15.8927 49.9633C14.0406 48.5975 12.3644 47.1592 10.8537 45.6486C11.7332 40.413 9.74662 35.9017 6.40454 31.9802C9.35343 35.7569 11.1124 40.1336 10.295 45.0795C4.70764 39.2645 1.50008 32.5597 0.351562 26.1445ZM23.8909 37.133V37.1123L23.7668 36.9882C23.8082 37.0399 23.8495 37.0813 23.8909 37.133Z",
    fill: "url(#paint18_linear_318_3152)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5744 59.5664C31.4259 59.9699 30.236 60.4666 29.0151 61.0253C24.5969 63.0326 17.861 68.4234 12.791 66.561C16.2573 69.4271 17.1161 71.9621 19.9718 74.2177C21.2445 75.2214 22.9 76.3389 24.7521 77.4046C26.18 78.2324 27.6493 78.5117 29.2841 78.2737C29.9463 78.1806 30.6292 78.0254 31.3949 77.8288C31.0845 78.0668 30.0291 78.5117 29.729 78.6669C29.5117 78.7807 29.4703 79.0911 29.2841 79.236C29.1289 79.3498 28.9633 79.4326 28.7874 79.4947C32.6676 81.2537 36.796 82.4229 39.8794 81.8538C43.6043 81.1605 46.2635 79.4223 48.4157 77.0011C48.2812 76.8976 48.1363 76.8045 48.0018 76.701C41.8143 72.1794 36.6822 66.0747 32.5848 59.5768L32.5744 59.5664Z",
    fill: "url(#paint19_linear_318_3152)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0406 73.4005C21.5135 73.7626 23.6967 73.7523 27.0698 73.3591C23.3242 72.9245 19.9925 72.1381 16.9402 71.0207C15.833 69.6238 14.7156 68.1339 12.791 66.5508C20.0546 69.7066 27.0698 71.6829 34.9025 72.8107C30.712 76.2356 28.3943 76.9805 23.4898 76.6494C22.7552 76.1942 22.0619 75.7389 21.4204 75.2836C22.124 75.2215 22.7965 75.0663 23.4587 74.8698C22.1964 74.7766 21.2962 74.6318 20.1995 74.3938C20.1167 74.3317 20.0442 74.2696 19.9718 74.2075C19.6304 73.9385 19.32 73.6695 19.0302 73.4005H19.0406Z",
    fill: "url(#paint20_linear_318_3152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.754 72.8519C29.5525 72.8416 15.7083 68.0406 12.8008 66.561C17.8708 68.4234 24.6067 63.0326 29.0248 61.0253C30.2458 60.4666 31.4253 59.9699 32.5842 59.5664C35.4607 64.1191 38.8338 68.4752 42.7242 72.2415C40.7376 72.6036 38.7614 72.8623 36.754 72.8623V72.8519Z",
    fill: "url(#paint21_linear_318_3152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7709 59.8768L32.5743 59.5664C32.2225 59.6906 31.8811 59.8147 31.5293 59.9596C31.9432 59.9182 32.3571 59.8872 32.7709 59.8768ZM48.4052 76.9907C48.2707 76.8872 48.1259 76.7941 47.9913 76.6907C47.2877 76.1733 46.5945 75.6353 45.9116 75.0765C44.8666 77.3115 42.8489 79.1636 40.0966 80.1776C37.4064 81.1812 35.3887 81.2847 32.6882 80.995C35.2956 81.8228 37.8203 82.2159 39.869 81.8331C43.5939 81.1399 46.253 79.4016 48.4052 76.9804V76.9907Z",
    fill: "url(#paint22_linear_318_3152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8008 66.5614C17.6639 68.486 24.8654 70.9589 31.7668 71.9626C28.1971 68.1238 27.2659 66.9029 21.8544 65.3405C27.0382 65.9924 29.1594 68.5481 32.6152 72.0764C35.3468 72.4282 38.1819 72.5523 40.9239 72.1902C38.5234 68.5688 36.7644 66.7477 32.2634 65.0508C36.1643 66.2096 38.8441 68.2376 41.2446 71.4245C41.6482 71.9626 41.9482 72.0246 42.4242 71.9522C42.7035 72.2316 42.9933 72.511 43.283 72.78C43.0036 73.0283 42.7656 73.3491 42.3414 73.7629C38.9166 77.1154 35.6366 79.4848 30.7631 79.9401C35.7297 78.8123 38.8959 77.1257 42.4242 72.6455C40.4479 72.9869 38.513 73.2145 36.7437 73.2456C34.8295 73.2663 35.7193 72.8938 34.1569 73.9699C30.7942 76.3083 28.8489 77.0429 24.1618 76.7222C29.3559 76.4221 30.3079 76.0496 34.2087 73.1111C28.3626 72.4282 16.7947 69.0137 12.8111 66.5614H12.8008ZM44.8661 74.1975C44.9902 74.301 45.1144 74.4148 45.2386 74.5183C43.3347 76.4945 41.2757 78.119 38.4923 79.4434C40.8721 78.1604 43.2106 75.9979 44.8661 74.1975Z",
    fill: "url(#paint23_linear_318_3152)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_3152",
    x1: 25.2278,
    y1: 12.0646,
    x2: 40.9656,
    y2: 12.0646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#6179AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#90A8D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#A1BCE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#B1D0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#B7D8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE4F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_318_3152",
    x1: 25.9199,
    y1: 12.3228,
    x2: 32.1385,
    y2: 12.3228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98C0D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_318_3152",
    x1: 27.6498,
    y1: 12.062,
    x2: 40.9664,
    y2: 12.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E96B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_318_3152",
    x1: 29.7397,
    y1: 3.34989,
    x2: 40.9661,
    y2: 3.34989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98C0D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_318_3152",
    x1: 26.0873,
    y1: 12.062,
    x2: 40.9663,
    y2: 12.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_318_3152",
    x1: 21.3589,
    y1: 41.339,
    x2: 21.3589,
    y2: 2.35156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#6179AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#90A8D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#A1BCE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#B1D0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#B7D8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE4F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_318_3152",
    x1: 10.536,
    y1: 21.8453,
    x2: 24.939,
    y2: 21.8453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_318_3152",
    x1: 17.4784,
    y1: 25.0193,
    x2: 17.4784,
    y2: 2.34903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98C0D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_318_3152",
    x1: 19.6498,
    y1: 16.8671,
    x2: 26.1581,
    y2: 16.8671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98C0D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_318_3152",
    x1: 20.8945,
    y1: 24.0374,
    x2: 31.6864,
    y2: 24.0374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98C0D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_318_3152",
    x1: 21.5627,
    y1: 41.3354,
    x2: 21.5627,
    y2: 15.5611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#887BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_318_3152",
    x1: 11.2279,
    y1: 19.1187,
    x2: 31.4873,
    y2: 19.1187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_318_3152",
    x1: 0.00179593,
    y1: 44.8143,
    x2: 33.2466,
    y2: 44.8143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_318_3152",
    x1: 0.106683,
    y1: 45.0071,
    x2: 33.3515,
    y2: 45.0071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_318_3152",
    x1: 8.2709,
    y1: 49.8811,
    x2: 33.352,
    y2: 49.8811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1E5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#516CA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_318_3152",
    x1: 18.5838,
    y1: 53.3821,
    x2: 18.5838,
    y2: 34.1367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98C0D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_318_3152",
    x1: 4.22378,
    y1: 45.1636,
    x2: 4.22378,
    y2: 26.1459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98C0D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_318_3152",
    x1: 24.4926,
    y1: 55.2971,
    x2: 24.4926,
    y2: 40.8424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98C0D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_318_3152",
    x1: 0.351563,
    y1: 43.1446,
    x2: 32.7376,
    y2: 43.1446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_318_3152",
    x1: 12.791,
    y1: 70.7722,
    x2: 48.4053,
    y2: 70.7722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90A8D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#586B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_318_3152",
    x1: 12.791,
    y1: 71.6415,
    x2: 34.9129,
    y2: 71.6415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98C0D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F4F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_318_3152",
    x1: 12.7904,
    y1: 66.2092,
    x2: 42.7139,
    y2: 66.2092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#B2D7F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#819DC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#5D729F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#47588A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F4F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_318_3152",
    x1: 31.5189,
    y1: 70.7722,
    x2: 48.4052,
    y2: 70.7722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_318_3152",
    x1: 12.7904,
    y1: 72.4903,
    x2: 45.2386,
    y2: 72.4903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonWingLeft);
export default __webpack_public_path__ + "static/media/button-wing-left.66a429ba5a64aeac89fccaa41e352134.svg";
export { ForwardRef as ReactComponent };